"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticatedCirrusContext = void 0;
const react_1 = require("react");
exports.AuthenticatedCirrusContext = react_1.createContext({
    signOut: () => {
        throw new Error('No authenticated socket in context.');
    },
    authenticationMethod: null,
    sessionId: '',
});
//# sourceMappingURL=AuthenticatedCirrusContext.js.map